export const BRAND_LOGO = "https://customer-assets.emergentagent.com/job_luxury-circle-3/artifacts/le4aupa6_SocialCircle.jpg";

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1777063660133-bb6854a4fecc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb2NrdGFpbCUyMGJhciUyMGxvdW5nZXxlbnwwfHx8fDE3NzgzNjIyODF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1776993298576-dd8a9205926f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGludGVyaW9yfGVufDB8fHx8MTc3ODM2MjI4Mnww&ixlib=rb-4.1.0&q=85",
];

export const GALLERY_IMAGES = [
  "https://images.unsplash.com/photo-1574154894072-18ba0d48321b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxuaWdodGNsdWIlMjBkaiUyMGNyb3dkfGVufDB8fHx8MTc3ODM2MjI4MXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1764768780701-7658be9a9bc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjaGFtcGFnbmUlMjBnbGFzcyUyMG5pZ2h0bGlmZXxlbnwwfHx8fDE3NzgzNjIyODF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/36183154/pexels-photo-36183154.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1762843352724-1cf16d055028?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxjaGFtcGFnbmUlMjBnbGFzcyUyMG5pZ2h0bGlmZXxlbnwwfHx8fDE3NzgzNjIyODF8MA&ixlib=rb-4.1.0&q=85",
];

export function discountLabel(type, value) {
  if (value === undefined || value === null) return "—";
  return (type === "percentage" || type === "percent") ? `${value}% OFF` : `₱${value} OFF`;
}

export function discountTypeLabel(type) {
  return (type === "percentage" || type === "percent") ? "Percentage" : "Fixed";
}

export function formatMoney(n) {
  if (n === null || n === undefined) return "₱0";
  return "₱" + Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function shortDate(s) {
  if (!s) return "";
  try { return new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return s; }
}
